import styles from './NoAuth.module.scss'

export const NoAuth = ({children}: any): JSX.Element => (
  <div className={styles.layout}>{children}</div>
)
